import { FormGroup } from '@angular/forms';

export function matchPasswordValidator(form: FormGroup) {
  const password = form.get('password');
  const confirmPassword = form.get('passwordConfirm');

  if (!password || !confirmPassword) return null;

  const mismatch = password.value !== confirmPassword.value;

  if (mismatch) {
    confirmPassword.setErrors({ mismatch: true });
  } else {
    // Make sure we clear mismatch error if previously set
    const errors = confirmPassword.errors;
    if (errors) {
      delete errors.mismatch;
      if (Object.keys(errors).length === 0) {
        confirmPassword.setErrors(null);
      } else {
        confirmPassword.setErrors(errors);
      }
    }
  }

  return null;
}
